import Table from "components/Table";
import { COMMISSION_SOURCE_TABS } from "./commissionsConstants";

const formatCurrency = (value) =>
  `$${Number(value || 0).toLocaleString("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;

const formatLabel = (value) =>
  COMMISSION_SOURCE_TABS.find((t) => t.value === value)?.label ??
  value
    ?.split("_")
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(" ") ??
  "-";

const SOURCE_TYPE_LABELS = {
  stripe_sale: "Stripe sale",
  ghl_attribution: "GHL attribution",
  monthly_profit_share: "Monthly profit share",
};

const formatSourceType = (value) => SOURCE_TYPE_LABELS[value] ?? value ?? "-";

const formatDescription = (item) => {
  const parts = [formatLabel(item.ruleCode), formatSourceType(item.sourceType)];
  if (item.periodMonth) parts.push(item.periodMonth);
  return parts.filter(Boolean).join(" · ");
};

const mapLogStatus = (item) => {
  if (item.accrualStatus === "reversed") return "reversed";
  if (item.payoutStatus === "paid") return "paid";
  if (item.payoutStatus === "partial") return "pending";
  return "owed";
};

const STATUS_STYLES = {
  paid: "bg-green-100 text-green-800",
  owed: "bg-amber-100 text-amber-800",
  pending: "bg-gray-100 text-gray-800",
  reversed: "bg-red-100 text-red-800",
};

const StatusBadge = ({ status }) => (
  <span
    className={`inline-flex px-2 py-0.5 rounded-full text-xs font-medium ${
      STATUS_STYLES[status] || "bg-gray-100 text-gray-800"
    }`}
  >
    {status.charAt(0).toUpperCase() + status.slice(1)}
  </span>
);

const columns = [
  {
    key: "date",
    label: "Date",
    render: (item) =>
      item.date ? new Date(item.date).toLocaleDateString("en-GB") : "-",
  },
  {
    key: "source",
    label: "Source",
    render: (item) => formatLabel(item.ruleCode),
  },
  {
    key: "description",
    label: "Description",
    render: (item) => formatDescription(item),
  },
  {
    key: "amount",
    label: "Amount",
    render: (item) => formatCurrency(item.commissionAmount),
    className: "text-right",
    headerClassName: "text-right",
    heaserTextAlign: "justify-end",
  },
  {
    key: "status",
    label: "Status",
    render: (item) => <StatusBadge status={mapLogStatus(item)} />,
  },
];

export default function CommissionsLogTable({
  commissionLog = [],
  isLoading = false,
  error = null,
  onRetry,
}) {
  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
      <div className="px-4 py-3 border-b border-gray-200">
        <h3 className="text-lg font-medium text-gray-900">Commissions Log</h3>
      </div>

      <Table
        columns={columns}
        data={commissionLog}
        isLoading={isLoading}
        error={error}
        onRetry={onRetry}
        emptyMessage="No commission records found."
      />
    </div>
  );
}
